/**
 * 获取当前节点的父节点
 * data:目标数组
 * key:遍历的关键字段
 * */
export function getParentNode(data, key) {
    let result = null
    for (let i = 0; i < data.length; i++) {
        if (data[i].groupList) {
            if (data[i].groupList.some(item => item["$treeNodeId"] === key)) {
                result = data[i]
                break
            } else {
                const temp = getParentNode(data[i].groupList, key)
                if (temp) {
                    result = temp
                    break
                }
            }
        }
    }
    return result
}

/**
 * 获取当前节点的所有祖先节点
 * data:目标数组
 * key:遍历的关键字段
 * */
export function getAllParentNode(data, key) {
    const arr = []
    const fn = (data, key) => {
        const p = getParentNode(data, key)
        if (p && p["$treeNodeId"]) {
            arr.push(p)
            fn(data, p["$treeNodeId"])
        }
    }
    fn(data, key)
    return arr
}

/**
 * 获取当前节点的所有兄弟节点
 * data:目标数组
 * key:遍历的关键字段
 * */
export function getAllSiblingNode(data, key) {

    let parentNode = getParentNode(data, key);
    let siblingNodeList = [];
    if (!parentNode) {
        // 顶层
        siblingNodeList = data
    } else {
        siblingNodeList = parentNode.groupList ? parentNode.groupList : []
    }
    return siblingNodeList
}